import { useEffect } from 'react';

import { useNavigate, useParams } from 'react-router';
import generateB2DPath from '../../../../../../utils/generateB2DPath';

import useDomain from '../../../../../../hooks/useDomain';
import { useMultiAnnonceContext } from '../../../../views/forms/multi/RegisterMultiInvoiceView';

export const NextDossierSaisieMultiple = function () {
    const { factureachatid } = useParams();
    const { mediaObject } = useMultiAnnonceContext();
    const navigate = useNavigate();
    const { resetDomain } = useDomain();

    if (!factureachatid) {
        console.error('FactureAchatId is undefined !');
    }

    useEffect(() => {
        resetDomain();

        const res = generateB2DPath('formmultiadddossier', {
            factureAchat: { id: Number(factureachatid) },
            mediaObjectId: mediaObject.id,
        });

        if (res.status === 'OK') {
            navigate(res.path);
        } else {
            // TODO
        }
    }, [factureachatid, mediaObject.id, navigate, resetDomain]);

    return null;
};

export default NextDossierSaisieMultiple;
